module.exports = __webpack_public_path__ + "static/img/kaishu_header.78492401.jpg";